import { render, staticRenderFns } from "./AuthenticationResetConfirmation.vue?vue&type=template&id=5cddd242&"
import script from "./AuthenticationResetConfirmation.vue?vue&type=script&lang=js&"
export * from "./AuthenticationResetConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cddd242')) {
      api.createRecord('5cddd242', component.options)
    } else {
      api.reload('5cddd242', component.options)
    }
    module.hot.accept("./AuthenticationResetConfirmation.vue?vue&type=template&id=5cddd242&", function () {
      api.rerender('5cddd242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AuthenticationResetConfirmation.vue"
export default component.exports